import actions from './actions';
import getters from './getters';
import mutations from './mutations';

const state = {
  orders: {
    data: [],
    queryParams: {
      pageNum: 1,
      pageSize: 25,
      sortBy: 'datum',
      sortDesc: true,
      query: null,
      customerId: null,
    },
    loading: false,
    tableHeadings: {
      dobavljac: {
        title: 'Dobavljač',
        sortBy: false,
        sortDesc: true,
      },
      broj: {
        title: 'Broj',
        sortBy: false,
        sortDesc: true,
      },
      datum: {
        title: 'Datum',
        sortBy: true,
        sortDesc: true,
      },
    },
  },
  order: {
    info: {},
    data: [],
    pageData: [],
    sendOrderAllowed: true,
    orderSupplierId: null,
    queryParams: {
      pageNum: 1,
      pageSize: 30,
    },
    loading: false,
    tableHeadings: {
      sifra: {
        title: 'Lokalna šifra',
        exists: true,
      },
      naziv: {
        title: 'Naziv',
        exists: true,
      },
      proizvodjac: {
        title: 'Proizvođač',
        exists: true,
      },
      kolicina: {
        title: 'Kolicina',
        exists: true,
      },
      napomena: {
        title: 'Napomena',
        exists: [1645, 1036],
      },
      cena: {
        title: 'Cena',
        exists: [1645, 1036],
      },
      rabat: {
        title: 'Rabat',
        exists: [1645],
      },
      popust: {
        title: 'Popust',
        exists: [1645],
      },
    },
  },
};

export default {
  namespaced: true,
  state,
  actions,
  getters,
  mutations,
};
